import React from 'react'
import './widgetStyle.css'

import Chat1 from 'layouts/CustomizeDrift/chat_solid_1'
import Chat2 from 'layouts/CustomizeDrift/chat_solid_2'
import Chat3 from 'layouts/CustomizeDrift/chat_outline_1'
import Chat4 from 'layouts/CustomizeDrift/chat_outline_2'

const icon = (iconStyle) => {
  if (iconStyle === 'SOLID1') {
    return (
      <Chat1/>
    )
  } else if (iconStyle === 'SOLID2') {
    return (
      <Chat2/>
    )
  } else if (iconStyle === 'OUTLINE1') {
    return (
      <Chat3/>
    )
  } else {
    return (
      <Chat4/>
    )
  }
}

const Widget = ({
  iconStyle,
  backgroundColor,
  foregroundColor,
}) => {
  return (
    <div
      className="Widget"
      style={{ backgroundColor: `#${backgroundColor}`, color: `#${foregroundColor}`}}
    >
      {icon(iconStyle)}
    </div>
  )
}

export default Widget